/**
 * Partial multi-resolution start: only some legs run (e.g. 2/3), the schedule keeps status 0 so the server retries the
 * missing legs. The server adds `partial_start` {running,total} to such rows (optional: absent = not partial).
 */
export interface PartialStart {
  running: number;
  total: number;
}

interface WithPartial {
  status: number;
  partial_start?: PartialStart | null;
}

export function isPartialStart(ev: WithPartial): boolean {
  return ev.status === 0 && !!ev.partial_start;
}

export function partialBadgeText(p: PartialStart): string {
  return `${p.running}/${p.total}`;
}

/** Dashboard "In Onda" card: live events plus the partially started ones. */
export function isOnAirCard(ev: WithPartial): boolean {
  return ev.status === 1 || isPartialStart(ev);
}
